// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ik-dashboard {
  padding: 20px;
  min-height: 100vh;
}

.ik-dashboard.dark {
  background: var(--dark-bg, #141414);
}

.ik-dashboard.light {
  background: var(--color-bg-secondary, #f0f2f5);
}

.ik-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
}

.ik-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ik-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.ik-card .ant-card-head {
  padding: 12px 16px;
  min-height: 48px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.ik-card .ant-card-head-title {
  padding: 0;
  font-size: 14px;
  font-weight: 600;
}

.ik-card .ant-card-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Compact Cards */
.ik-card-compact {
  min-height: auto;
  height: auto;
}

.ik-card-compact .ant-card-body {
  padding: 0 16px 8px 16px;
  min-height: auto;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.ik-card-compact .ant-card-body > * {
  margin-top: 0;
}

.ik-card-compact .ant-empty {
  padding: 0;
  margin: 0;
  width: 100%;
}

.ik-card-compact .ant-empty-image {
  height: 28px;
  margin-bottom: 2px;
}

.ik-card-compact .ant-empty-description {
  font-size: 11px;
  margin: 0;
}

.ik-dashboard.dark .ik-card {
  background: var(--dark-bg-secondary, #1f1f1f);
  border-color: rgba(255, 255, 255, 0.1);
}

.ik-dashboard.dark .ik-card .ant-card-head {
  border-bottom-color: rgba(255, 255, 255, 0.1);
}

.ik-dashboard.dark .ik-card .ant-card-head-title {
  color: rgba(255, 255, 255, 0.85);
}

.ik-dashboard.dark .ik-card .ant-card-body {
  color: rgba(255, 255, 255, 0.85);
}

/* Chart Container */
.chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 280px;
}

.chart-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
  color: inherit;
  text-align: center;
}

.chart-wrapper {
  width: 100%;
  max-width: 300px;
  height: 280px;
  position: relative;
}

/* Table Styles */
.ik-table {
  font-size: 10px;
}

.ik-table .ant-table {
  font-size: 10px;
}

.ik-table .ant-table-thead > tr > th {
  padding: 6px;
  font-size: 10px;
  font-weight: 600;
  background: transparent;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.ik-dashboard.dark .ik-table .ant-table-thead > tr > th {
  border-bottom-color: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.85);
}

.ik-table .ant-table-tbody > tr > td {
  padding: 8px;
  font-size: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.ik-dashboard.dark .ik-table .ant-table-tbody > tr > td {
  border-bottom-color: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.85);
}

.ik-table .ant-table-tbody > tr:hover > td {
  background: rgba(0, 0, 0, 0.02);
}

.ik-dashboard.dark .ik-table .ant-table-tbody > tr:hover > td {
  background: rgba(255, 255, 255, 0.05);
}

.ik-table .ant-empty {
  margin: 20px 0;
}

.ik-table .ant-empty-description {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}

.ik-dashboard.dark .ik-table .ant-empty-description {
  color: rgba(255, 255, 255, 0.45);
}

/* Avatar Styles */
.ik-table .ant-avatar {
  flex-shrink: 0;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .chart-wrapper {
    max-width: 250px;
    height: 340px;
  }
  
  .chart-container {
    min-height: 240px;
  }
}

@media (max-width: 768px) {
  .ik-dashboard {
    padding: 12px;
  }
  
  .ik-card {
    margin-bottom: 16px;
  }
  
  .chart-wrapper {
    max-width: 200px;
    height: 180px;
  }
  
  .chart-container {
    min-height: 200px;
  }
  
  .ik-table {
    font-size: 11px;
  }
  
  .ik-table .ant-table-thead > tr > th,
  .ik-table .ant-table-tbody > tr > td {
    padding: 6px 4px;
    font-size: 11px;
  }
}

@media (max-width: 576px) {
  .ik-dashboard {
    padding: 8px;
  }
  
  .ik-card .ant-card-body {
    padding: 12px;
  }
  
  .chart-wrapper {
    max-width: 180px;
    height: 160px;
  }
  
  .chart-container {
    min-height: 180px;
  }
}

/* Compact spacing for cards */
.ik-card + .ik-card {
  margin-top: 16px;
}

/* Empty state styling */
.ant-empty {
  padding: 20px 0;
}

.ant-empty-image {
  height: 40px;
  margin-bottom: 8px;
}

/* Link styling in card headers */
.ik-card .ant-card-head-title a {
  color: inherit;
  transition: color 0.3s;
}

.ik-card .ant-card-head-title a:hover {
  color: #1890ff;
}

.ik-dashboard.dark .ik-card .ant-card-head-title a:hover {
  color: #40a9ff;
}

/* Compact card hover effect */
.ik-card-compact:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Badge in title */
.ik-card .ant-card-head-title .ant-badge {
  margin-left: 8px;
}

.ik-card .ant-card-head-title .ant-badge-count {
  cursor: pointer;
  transition: transform 0.2s;
}

.ik-card .ant-card-head-title .ant-badge-count:hover {
  transform: scale(1.1);
}

/* Modal Styles */
.ik-modal .ant-modal-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.ik-dashboard.dark .ik-modal .ant-modal-header {
  border-bottom-color: rgba(255, 255, 255, 0.1);
  background: var(--dark-bg-secondary, #1f1f1f);
}

.ik-dashboard.dark .ik-modal .ant-modal-body {
  background: var(--dark-bg-secondary, #1f1f1f);
}

.ik-dashboard.dark .ik-modal .ant-modal-title {
  color: rgba(255, 255, 255, 0.85);
}

/* İzin Talebi modal */
body[data-theme="dark"] .ik-modal .izin-onayla-btn {
  background-color: #52c41a !important;
  border-color: #52c41a !important;
  color: #fff !important;
}
body[data-theme="dark"] .ik-modal .izin-onayla-btn:hover,
body[data-theme="dark"] .ik-modal .izin-onayla-btn:focus,
body[data-theme="dark"] .ik-modal .izin-onayla-btn:active {
  background-color: #73d13d !important;
  border-color: #73d13d !important;
  color: #fff !important;
}
body[data-theme="dark"] .ik-modal .izin-onayla-btn .anticon {
  color: #fff !important;
}
body[data-theme="dark"] .ik-modal .izin-reddet-btn {
  background-color: #ff4d4f !important;
  border-color: #ff4d4f !important;
  color: #fff !important;
}
body[data-theme="dark"] .ik-modal .izin-reddet-btn:hover,
body[data-theme="dark"] .ik-modal .izin-reddet-btn:focus,
body[data-theme="dark"] .ik-modal .izin-reddet-btn:active {
  background-color: #ff7875 !important;
  border-color: #ff7875 !important;
  color: #fff !important;
}
body[data-theme="dark"] .ik-modal .izin-reddet-btn .anticon {
  color: #fff !important;
}

/* Responsive improvements */
@media (max-width: 1200px) {
  .chart-wrapper {
    max-width: 250px;
    height: 240px;
  }
}

/* Menu Selector */
.ik-menu-selector {
  margin-bottom: 16px;
}

.ik-menu-selector .ant-space {
  width: 100%;
  display: flex;
  align-items: center;
}

.ik-menu-select {
  width: 100%;
}

.ik-menu-select .ant-select-selector {
  border-radius: 6px;
  min-height: 40px;
  padding: 4px 11px;
}

.ik-dashboard.dark .ik-menu-select .ant-select-selector {
  background: var(--dark-bg-secondary, #1f1f1f);
  border-color: rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.85);
}

.ik-dashboard.dark .ik-menu-select .ant-select-selection-item {
  color: rgba(255, 255, 255, 0.85);
}

.ik-dashboard.dark .ik-menu-select .ant-select-arrow {
  color: rgba(255, 255, 255, 0.45);
}

/* FaturaPage style table for ik.jsx */
.ik-table-view {
  padding: 0;
}

.ik-table-view .ant-card {
  margin-bottom: 0;
}

.ik-table-view .ant-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* width:100%!important, rc-table'in <table> uzerine koydugu inline
   width:max-content degerini eziyordu; boylece scroll={{x:'max-content'}}
   verilse bile tablo asla yatay kaymiyor, kolonlar sikisiyordu.
   min-width ile tablo dar ekranda konteyneri doldurur ama icerik tastiginda
   genisleyip yatay kaydirmaya izin verir. */
.ik-table-view .ant-table {
  min-width: 100%;
}

.ik-table-view .ant-table table {
  min-width: 100%;
}

.ik-table-view .ant-table-container {
  min-width: 100%;
}

.ik-table-view .ant-table-tbody > tr > td {
  padding: 2px 4px !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
  overflow: visible !important;
  font-size: 10px !important;
  line-height: 1.2 !important;
  height: auto !important;
  text-overflow: clip !important;
}

.ik-table-view .ant-table-tbody > tr > td > div:not(:has(.ant-space)),
.ik-table-view .ant-table-tbody > tr > td > span,
.ik-table-view .ant-table-tbody > tr > td > p {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
  overflow: visible !important;
  text-overflow: clip !important;
  display: block !important;
  box-sizing: border-box !important;
  hyphens: auto !important;
}

.ik-table-view .ant-table-tbody > tr > td > div:has(.ant-space) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.ik-table-view .ant-table-tbody > tr {
  height: auto !important;
}

.ik-table-view .ant-table-tbody > tr > td * {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}

.ik-table-view .ant-table-tbody > tr > td *:not(.ant-btn):not(.ant-space):not(.ant-space-item):not(:has(.ant-space)) {
  display: block !important;
  box-sizing: border-box !important;
}

.ik-table-view .ant-table-tbody > tr > td {
  vertical-align: top !important;
}

/* Baslik 'nowrap', govde 'normal' idi: ayni kolon icin baslik genis, govde dar
   genislik talep ediyordu ve max-content ile kolon genisligi iki tarafta farkli
   hesaplaniyordu. Baslik da sarmali ki iki taraf ayni genisligi istesin. */
.ik-table-view .ant-table-thead > tr > th {
  padding: 4px 6px !important;
  font-weight: 400 !important;
  background-color: #fafafa;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: clip !important;
  font-size: 10px !important;
  line-height: 1.2 !important;
}

.ik-table-view .ant-table-tbody > tr:hover > td {
  background-color: #f5f5f5;
}

.ik-table-view .ant-table-tbody > tr > td .ant-btn {
  font-size: 12px !important;
  min-height: 28px !important;
  height: auto !important;
  padding: 6px 12px !important;
  line-height: 1.5 !important;
  white-space: nowrap !important;
  min-width: 90px !important;
  max-width: 120px !important;
  width: auto !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-left: auto !important;
  margin-right: auto !important;
  text-align: center !important;
}

.ik-table-view .ant-table-tbody > tr > td .ant-btn .anticon {
  font-size: 12px !important;
  margin-right: 6px !important;
  flex-shrink: 0 !important;
}

.ik-table-view .ant-table-tbody > tr > td .ant-space {
  width: auto !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 4px !important;
  align-items: center !important;
  justify-content: center !important;
}

.ik-table-view .ant-table-tbody > tr > td .ant-space-item {
  width: auto !important;
}

.ik-table-view .ant-table-thead > tr > th .ant-btn {
  font-size: 10px !important;
  height: 16px !important;
  padding: 0 2px !important;
  line-height: 1.2 !important;
}

.ik-table-view .ant-table-thead > tr > th .ant-btn .anticon {
  font-size: 10px !important;
}

.ik-table-view .filter-item {
  margin-bottom: 8px;
}

.ik-table-view .filter-item .ant-typography {
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
  color: #666;
}

.ik-table-view .filter-actions {
  display: flex;
  align-items: flex-end;
  height: 100%;
  padding-top: 20px;
}

/* Dark mode for ik-table-view */
.ik-dashboard.dark .ik-table-view .ant-card {
  background-color: var(--dark-bg-secondary) !important;
  border-color: var(--dark-border) !important;
}

.ik-dashboard.dark .ik-table-view .ant-table-thead > tr > th {
  background-color: var(--dark-bg-header) !important;
  color: var(--dark-text) !important;
  border-bottom-color: var(--dark-border) !important;
  padding: 4px 6px !important;
  font-size: 10px !important;
  line-height: 1.2 !important;
  font-weight: 600 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.ik-dashboard.dark .ik-table-view .ant-table-tbody > tr:hover > td {
  background-color: var(--dark-bg-header) !important;
  padding: 2px 4px !important;
  font-size: 10px !important;
  line-height: 1.2 !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  overflow: visible !important;
  height: auto !important;
  text-overflow: clip !important;
}

.ik-dashboard.dark .ik-table-view .ant-table-tbody > tr > td .ant-btn {
  background-color: var(--dark-bg-header) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

.ik-dashboard.dark .ik-table-view .ant-table-tbody > tr > td .ant-btn:hover {
  background-color: var(--dark-bg) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

.ik-dashboard.dark .ik-table-view .ant-table-tbody > tr > td {
  background-color: var(--dark-bg-secondary) !important;
  color: var(--dark-text) !important;
  border-bottom-color: var(--dark-border) !important;
  padding: 2px 4px !important;
  font-size: 10px !important;
  line-height: 1.2 !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  overflow: visible !important;
  height: auto !important;
  text-overflow: clip !important;
}

.ik-dashboard.dark .ik-table-view .filter-item .ant-typography {
  color: var(--dark-text) !important;
}

/* Table View Styles */
.ik-dashboard .ant-table {
  background: transparent;
}

.ik-dashboard.dark .ant-table {
  background: var(--dark-bg-secondary, #1f1f1f);
  color: rgba(255, 255, 255, 0.85);
}

.ik-dashboard.dark .ant-table-thead > tr > th {
  background: var(--dark-bg-secondary, #1f1f1f);
  border-bottom-color: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.85);
}

.ik-dashboard.dark .ant-table-tbody > tr > td {
  border-bottom-color: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.85);
}

.ik-dashboard.dark .ant-table-tbody > tr:hover > td {
  background: rgba(255, 255, 255, 0.05);
}

.ik-dashboard.dark .ant-pagination-item {
  background: var(--dark-bg-secondary, #1f1f1f);
  border-color: rgba(255, 255, 255, 0.2);
}

.ik-dashboard.dark .ant-pagination-item a {
  color: rgba(255, 255, 255, 0.85);
}

.ik-dashboard.dark .ant-pagination-item-active {
  background: #1890ff;
  border-color: #1890ff;
}

.ik-dashboard.dark .ant-pagination-item-active a {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/ik/ik.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;EAC7C,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;AACA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;AACA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,sCAAsC;AACtC;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;;;;4CAI4C;AAC5C;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,iCAAiC;EACjC,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;;;EAGE,8BAA8B;EAC9B,gCAAgC;EAChC,iCAAiC;EACjC,oCAAoC;EACpC,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;2EAE2E;AAC3E;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA;EACE,kDAAkD;EAClD,kCAAkC;EAClC,kDAAkD;EAClD,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,kDAAkD;EAClD,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,iCAAiC;EACjC,4BAA4B;EAC5B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,kDAAkD;EAClD,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,qDAAqD;EACrD,kCAAkC;EAClC,kDAAkD;EAClD,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,iCAAiC;EACjC,4BAA4B;EAC5B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;AACzB;;AAEA;EACE,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;EAC7C,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".ik-dashboard {\n  padding: 20px;\n  min-height: 100vh;\n}\n\n.ik-dashboard.dark {\n  background: var(--dark-bg, #141414);\n}\n\n.ik-dashboard.light {\n  background: var(--color-bg-secondary, #f0f2f5);\n}\n\n.ik-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 80vh;\n}\n\n.ik-card {\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.ik-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.ik-card .ant-card-head {\n  padding: 12px 16px;\n  min-height: 48px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.ik-card .ant-card-head-title {\n  padding: 0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.ik-card .ant-card-body {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Compact Cards */\n.ik-card-compact {\n  min-height: auto;\n  height: auto;\n}\n\n.ik-card-compact .ant-card-body {\n  padding: 0 16px 8px 16px;\n  min-height: auto;\n  height: auto;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.ik-card-compact .ant-card-body > * {\n  margin-top: 0;\n}\n\n.ik-card-compact .ant-empty {\n  padding: 0;\n  margin: 0;\n  width: 100%;\n}\n\n.ik-card-compact .ant-empty-image {\n  height: 28px;\n  margin-bottom: 2px;\n}\n\n.ik-card-compact .ant-empty-description {\n  font-size: 11px;\n  margin: 0;\n}\n\n.ik-dashboard.dark .ik-card {\n  background: var(--dark-bg-secondary, #1f1f1f);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.ik-dashboard.dark .ik-card .ant-card-head {\n  border-bottom-color: rgba(255, 255, 255, 0.1);\n}\n\n.ik-dashboard.dark .ik-card .ant-card-head-title {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.ik-dashboard.dark .ik-card .ant-card-body {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n/* Chart Container */\n.chart-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 280px;\n}\n\n.chart-title {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 12px;\n  color: inherit;\n  text-align: center;\n}\n\n.chart-wrapper {\n  width: 100%;\n  max-width: 300px;\n  height: 280px;\n  position: relative;\n}\n\n/* Table Styles */\n.ik-table {\n  font-size: 10px;\n}\n\n.ik-table .ant-table {\n  font-size: 10px;\n}\n\n.ik-table .ant-table-thead > tr > th {\n  padding: 6px;\n  font-size: 10px;\n  font-weight: 600;\n  background: transparent;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.ik-dashboard.dark .ik-table .ant-table-thead > tr > th {\n  border-bottom-color: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.ik-table .ant-table-tbody > tr > td {\n  padding: 8px;\n  font-size: 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.ik-dashboard.dark .ik-table .ant-table-tbody > tr > td {\n  border-bottom-color: rgba(255, 255, 255, 0.08);\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.ik-table .ant-table-tbody > tr:hover > td {\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.ik-dashboard.dark .ik-table .ant-table-tbody > tr:hover > td {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.ik-table .ant-empty {\n  margin: 20px 0;\n}\n\n.ik-table .ant-empty-description {\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 12px;\n}\n\n.ik-dashboard.dark .ik-table .ant-empty-description {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n/* Avatar Styles */\n.ik-table .ant-avatar {\n  flex-shrink: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .chart-wrapper {\n    max-width: 250px;\n    height: 340px;\n  }\n  \n  .chart-container {\n    min-height: 240px;\n  }\n}\n\n@media (max-width: 768px) {\n  .ik-dashboard {\n    padding: 12px;\n  }\n  \n  .ik-card {\n    margin-bottom: 16px;\n  }\n  \n  .chart-wrapper {\n    max-width: 200px;\n    height: 180px;\n  }\n  \n  .chart-container {\n    min-height: 200px;\n  }\n  \n  .ik-table {\n    font-size: 11px;\n  }\n  \n  .ik-table .ant-table-thead > tr > th,\n  .ik-table .ant-table-tbody > tr > td {\n    padding: 6px 4px;\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 576px) {\n  .ik-dashboard {\n    padding: 8px;\n  }\n  \n  .ik-card .ant-card-body {\n    padding: 12px;\n  }\n  \n  .chart-wrapper {\n    max-width: 180px;\n    height: 160px;\n  }\n  \n  .chart-container {\n    min-height: 180px;\n  }\n}\n\n/* Compact spacing for cards */\n.ik-card + .ik-card {\n  margin-top: 16px;\n}\n\n/* Empty state styling */\n.ant-empty {\n  padding: 20px 0;\n}\n\n.ant-empty-image {\n  height: 40px;\n  margin-bottom: 8px;\n}\n\n/* Link styling in card headers */\n.ik-card .ant-card-head-title a {\n  color: inherit;\n  transition: color 0.3s;\n}\n\n.ik-card .ant-card-head-title a:hover {\n  color: #1890ff;\n}\n\n.ik-dashboard.dark .ik-card .ant-card-head-title a:hover {\n  color: #40a9ff;\n}\n\n/* Compact card hover effect */\n.ik-card-compact:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Badge in title */\n.ik-card .ant-card-head-title .ant-badge {\n  margin-left: 8px;\n}\n\n.ik-card .ant-card-head-title .ant-badge-count {\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.ik-card .ant-card-head-title .ant-badge-count:hover {\n  transform: scale(1.1);\n}\n\n/* Modal Styles */\n.ik-modal .ant-modal-header {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.ik-dashboard.dark .ik-modal .ant-modal-header {\n  border-bottom-color: rgba(255, 255, 255, 0.1);\n  background: var(--dark-bg-secondary, #1f1f1f);\n}\n\n.ik-dashboard.dark .ik-modal .ant-modal-body {\n  background: var(--dark-bg-secondary, #1f1f1f);\n}\n\n.ik-dashboard.dark .ik-modal .ant-modal-title {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n/* İzin Talebi modal */\nbody[data-theme=\"dark\"] .ik-modal .izin-onayla-btn {\n  background-color: #52c41a !important;\n  border-color: #52c41a !important;\n  color: #fff !important;\n}\nbody[data-theme=\"dark\"] .ik-modal .izin-onayla-btn:hover,\nbody[data-theme=\"dark\"] .ik-modal .izin-onayla-btn:focus,\nbody[data-theme=\"dark\"] .ik-modal .izin-onayla-btn:active {\n  background-color: #73d13d !important;\n  border-color: #73d13d !important;\n  color: #fff !important;\n}\nbody[data-theme=\"dark\"] .ik-modal .izin-onayla-btn .anticon {\n  color: #fff !important;\n}\nbody[data-theme=\"dark\"] .ik-modal .izin-reddet-btn {\n  background-color: #ff4d4f !important;\n  border-color: #ff4d4f !important;\n  color: #fff !important;\n}\nbody[data-theme=\"dark\"] .ik-modal .izin-reddet-btn:hover,\nbody[data-theme=\"dark\"] .ik-modal .izin-reddet-btn:focus,\nbody[data-theme=\"dark\"] .ik-modal .izin-reddet-btn:active {\n  background-color: #ff7875 !important;\n  border-color: #ff7875 !important;\n  color: #fff !important;\n}\nbody[data-theme=\"dark\"] .ik-modal .izin-reddet-btn .anticon {\n  color: #fff !important;\n}\n\n/* Responsive improvements */\n@media (max-width: 1200px) {\n  .chart-wrapper {\n    max-width: 250px;\n    height: 240px;\n  }\n}\n\n/* Menu Selector */\n.ik-menu-selector {\n  margin-bottom: 16px;\n}\n\n.ik-menu-selector .ant-space {\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.ik-menu-select {\n  width: 100%;\n}\n\n.ik-menu-select .ant-select-selector {\n  border-radius: 6px;\n  min-height: 40px;\n  padding: 4px 11px;\n}\n\n.ik-dashboard.dark .ik-menu-select .ant-select-selector {\n  background: var(--dark-bg-secondary, #1f1f1f);\n  border-color: rgba(255, 255, 255, 0.2);\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.ik-dashboard.dark .ik-menu-select .ant-select-selection-item {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.ik-dashboard.dark .ik-menu-select .ant-select-arrow {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n/* FaturaPage style table for ik.jsx */\n.ik-table-view {\n  padding: 0;\n}\n\n.ik-table-view .ant-card {\n  margin-bottom: 0;\n}\n\n.ik-table-view .ant-card {\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* width:100%!important, rc-table'in <table> uzerine koydugu inline\n   width:max-content degerini eziyordu; boylece scroll={{x:'max-content'}}\n   verilse bile tablo asla yatay kaymiyor, kolonlar sikisiyordu.\n   min-width ile tablo dar ekranda konteyneri doldurur ama icerik tastiginda\n   genisleyip yatay kaydirmaya izin verir. */\n.ik-table-view .ant-table {\n  min-width: 100%;\n}\n\n.ik-table-view .ant-table table {\n  min-width: 100%;\n}\n\n.ik-table-view .ant-table-container {\n  min-width: 100%;\n}\n\n.ik-table-view .ant-table-tbody > tr > td {\n  padding: 2px 4px !important;\n  white-space: normal !important;\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n  overflow-wrap: break-word !important;\n  overflow: visible !important;\n  font-size: 10px !important;\n  line-height: 1.2 !important;\n  height: auto !important;\n  text-overflow: clip !important;\n}\n\n.ik-table-view .ant-table-tbody > tr > td > div:not(:has(.ant-space)),\n.ik-table-view .ant-table-tbody > tr > td > span,\n.ik-table-view .ant-table-tbody > tr > td > p {\n  white-space: normal !important;\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n  overflow-wrap: break-word !important;\n  overflow: visible !important;\n  text-overflow: clip !important;\n  display: block !important;\n  box-sizing: border-box !important;\n  hyphens: auto !important;\n}\n\n.ik-table-view .ant-table-tbody > tr > td > div:has(.ant-space) {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.ik-table-view .ant-table-tbody > tr {\n  height: auto !important;\n}\n\n.ik-table-view .ant-table-tbody > tr > td * {\n  white-space: normal !important;\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n  overflow-wrap: break-word !important;\n}\n\n.ik-table-view .ant-table-tbody > tr > td *:not(.ant-btn):not(.ant-space):not(.ant-space-item):not(:has(.ant-space)) {\n  display: block !important;\n  box-sizing: border-box !important;\n}\n\n.ik-table-view .ant-table-tbody > tr > td {\n  vertical-align: top !important;\n}\n\n/* Baslik 'nowrap', govde 'normal' idi: ayni kolon icin baslik genis, govde dar\n   genislik talep ediyordu ve max-content ile kolon genisligi iki tarafta farkli\n   hesaplaniyordu. Baslik da sarmali ki iki taraf ayni genisligi istesin. */\n.ik-table-view .ant-table-thead > tr > th {\n  padding: 4px 6px !important;\n  font-weight: 400 !important;\n  background-color: #fafafa;\n  white-space: normal !important;\n  overflow: visible !important;\n  text-overflow: clip !important;\n  font-size: 10px !important;\n  line-height: 1.2 !important;\n}\n\n.ik-table-view .ant-table-tbody > tr:hover > td {\n  background-color: #f5f5f5;\n}\n\n.ik-table-view .ant-table-tbody > tr > td .ant-btn {\n  font-size: 12px !important;\n  min-height: 28px !important;\n  height: auto !important;\n  padding: 6px 12px !important;\n  line-height: 1.5 !important;\n  white-space: nowrap !important;\n  min-width: 90px !important;\n  max-width: 120px !important;\n  width: auto !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  margin-left: auto !important;\n  margin-right: auto !important;\n  text-align: center !important;\n}\n\n.ik-table-view .ant-table-tbody > tr > td .ant-btn .anticon {\n  font-size: 12px !important;\n  margin-right: 6px !important;\n  flex-shrink: 0 !important;\n}\n\n.ik-table-view .ant-table-tbody > tr > td .ant-space {\n  width: auto !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 4px !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.ik-table-view .ant-table-tbody > tr > td .ant-space-item {\n  width: auto !important;\n}\n\n.ik-table-view .ant-table-thead > tr > th .ant-btn {\n  font-size: 10px !important;\n  height: 16px !important;\n  padding: 0 2px !important;\n  line-height: 1.2 !important;\n}\n\n.ik-table-view .ant-table-thead > tr > th .ant-btn .anticon {\n  font-size: 10px !important;\n}\n\n.ik-table-view .filter-item {\n  margin-bottom: 8px;\n}\n\n.ik-table-view .filter-item .ant-typography {\n  display: block;\n  margin-bottom: 4px;\n  font-size: 14px;\n  color: #666;\n}\n\n.ik-table-view .filter-actions {\n  display: flex;\n  align-items: flex-end;\n  height: 100%;\n  padding-top: 20px;\n}\n\n/* Dark mode for ik-table-view */\n.ik-dashboard.dark .ik-table-view .ant-card {\n  background-color: var(--dark-bg-secondary) !important;\n  border-color: var(--dark-border) !important;\n}\n\n.ik-dashboard.dark .ik-table-view .ant-table-thead > tr > th {\n  background-color: var(--dark-bg-header) !important;\n  color: var(--dark-text) !important;\n  border-bottom-color: var(--dark-border) !important;\n  padding: 4px 6px !important;\n  font-size: 10px !important;\n  line-height: 1.2 !important;\n  font-weight: 600 !important;\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n\n.ik-dashboard.dark .ik-table-view .ant-table-tbody > tr:hover > td {\n  background-color: var(--dark-bg-header) !important;\n  padding: 2px 4px !important;\n  font-size: 10px !important;\n  line-height: 1.2 !important;\n  white-space: normal !important;\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n  overflow: visible !important;\n  height: auto !important;\n  text-overflow: clip !important;\n}\n\n.ik-dashboard.dark .ik-table-view .ant-table-tbody > tr > td .ant-btn {\n  background-color: var(--dark-bg-header) !important;\n  border-color: var(--dark-border) !important;\n  color: var(--dark-text) !important;\n}\n\n.ik-dashboard.dark .ik-table-view .ant-table-tbody > tr > td .ant-btn:hover {\n  background-color: var(--dark-bg) !important;\n  border-color: var(--dark-border) !important;\n  color: var(--dark-text) !important;\n}\n\n.ik-dashboard.dark .ik-table-view .ant-table-tbody > tr > td {\n  background-color: var(--dark-bg-secondary) !important;\n  color: var(--dark-text) !important;\n  border-bottom-color: var(--dark-border) !important;\n  padding: 2px 4px !important;\n  font-size: 10px !important;\n  line-height: 1.2 !important;\n  white-space: normal !important;\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n  overflow: visible !important;\n  height: auto !important;\n  text-overflow: clip !important;\n}\n\n.ik-dashboard.dark .ik-table-view .filter-item .ant-typography {\n  color: var(--dark-text) !important;\n}\n\n/* Table View Styles */\n.ik-dashboard .ant-table {\n  background: transparent;\n}\n\n.ik-dashboard.dark .ant-table {\n  background: var(--dark-bg-secondary, #1f1f1f);\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.ik-dashboard.dark .ant-table-thead > tr > th {\n  background: var(--dark-bg-secondary, #1f1f1f);\n  border-bottom-color: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.ik-dashboard.dark .ant-table-tbody > tr > td {\n  border-bottom-color: rgba(255, 255, 255, 0.08);\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.ik-dashboard.dark .ant-table-tbody > tr:hover > td {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.ik-dashboard.dark .ant-pagination-item {\n  background: var(--dark-bg-secondary, #1f1f1f);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.ik-dashboard.dark .ant-pagination-item a {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.ik-dashboard.dark .ant-pagination-item-active {\n  background: #1890ff;\n  border-color: #1890ff;\n}\n\n.ik-dashboard.dark .ant-pagination-item-active a {\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
